<template>
    <div class="container">
        <el-row style="margin-bottom: 12px;">
            <el-button type="primary"
                v-if="this.currentMenuOperations.some(func => func.name.includes('addItem'))"
                @click="showAddBox = true">新增分组</el-button>
        </el-row>
        <el-table
            :data="lists"
            style="width: 100%;margin-bottom: 20px;"
            row-key="id"
            :tree-props="{children: 'children', hasChildren: 'hasChildren'}">
            <el-table-column prop="label" label="名称"></el-table-column>
            <el-table-column label="地址">
                <template v-slot="{row}">
                    <a v-if="row.url" :href="row.url" target="blank">{{row.url}}</a>
                    <div v-else>
                        <div v-if="row.innerUrl">
                            内网地址：<a :href="row.innerUrl" target="blank">{{row.innerUrl}}</a>
                        </div>
                        <div v-if="row.wanUrl">
                            外网地址：<a :href="row.wanUrl" target="blank">{{row.wanUrl}}</a>
                        </div>
                        <div v-if="row.healthUrl">
                            健康检查：<a :href="row.healthUrl" target="blank">{{row.healthUrl}}</a>
                        </div>
                    </div>
                </template>
            </el-table-column>
            <el-table-column align="center" label="操作" width="300px"
                v-if="listOperations.length > 0"
            >
                <template v-slot="{row}">
                    <div v-if="!row.isLeaf">
                        <el-button v-for="btn in listOperations" :key="btn.id"
                            size="mini"
                            :type="btn.name.includes('del') ? 'danger' : 'primary'"
                            @click="go(btn, row)"
                        >{{btn.alias}}</el-button>
                    <!-- <el-button
                        size="mini"
                        type="primary"
                        @click="addSub(row)"
                    >添加子分组</el-button>

                    <el-button
                        size="mini"
                        type="primary"
                        @click="editSub(row)"
                    >编辑</el-button>

                    <el-button
                        size="mini"
                        type="danger"
                        @click="delConfirm(row)"
                    >删除</el-button> -->
                    </div>
                </template>
            </el-table-column>
        </el-table>

        <data-group-add v-if="showAddBox"
            :visible="showAddBox"
            :lists="lists"
            :type="openType"
            :row="currentRow"
            @addBoxCallback="addBoxCallback"
        />
    </div>
</template>
<script>
import { Loading } from "element-ui";
import DataGroupAdd from "./DataGroupAdd"
import { mapState, mapMutations } from 'vuex';
export default {
    components: { DataGroupAdd },
    data:vm=>({
        showAddBox: false,
        currentRow: null,
        parentId: null, //添加子分组时作为参数传入组件
        openType: 'add', //标识新增或编辑子分组
        lists: [],
    }),
    computed: {
        ...mapState(['currentMenu', 'listOperations', 'currentMenuOperations']),
    },
    created(){
        this.getListOperations('group')
        if(!this.currentMenu){
            return
        }
        this.getList()
    },
    methods: {
        ...mapMutations(['getListOperations']),
        go(btn, row){
            this[btn.name](row)
        },
        // 处理成页面需要的数据
        renderLists(data){
            const _this = this
            data.forEach(parent =>{
                let children = parent.children ? parent.children : []
                if(children.length > 0){
                    _this.renderLists(children)
                }
                if(parent.urls && parent.urls.length > 0){
                    parent.urls.forEach(url => {
                        children.push({
                            isLeaf: true,
                            label: url.name,
                            id: parent.id + url.insId,
                            insId: url.insId,
                            innerUrl: url.innerUrl,
                            wanUrl: url.wanUrl,
                            healthUrl: url.healthUrl
                        })
                    })
                }
                parent.children = children
            })
            this.lists = data
        },
        // 获取分组数据
        getList(){
            let loading = Loading.service({
                fullscreen: true,
                text: "数据加载中..."
            });
            this.lists = [];
            this.$axios.get(this.baseUrl3 + 'analyses/get/dataAnalyses/tree' )
                .then(({ data: { msg, data, code } }) => {
                    if (code == 20000) {
                        // this.lists = data
                        this.renderLists(data)
                    } else {
                        this.$message({ showClose: true, message: msg, type: "error" });
                        console.log(msg);
                    }
                    loading.close();
                })
                .catch(err => {
                    console.log(err)
                    loading.close();
                });
        },

        del(row){
            this.$axios
                .get(this.baseUrl3 + "analyses/del/dataAnalyses/treeNodeData/" + row.id)
                .then(({ data: { msg, data, code } }) => {
                    if (code == 20000) {
                        this.$message.success('操作成功')
                        this.getList()
                    } else {
                        this.$message({ showClose: true, message: msg, type: "error" });
                        console.log(msg);
                    }
                })
                .catch(error => {
                    this.$message({
                        showClose: true,
                        message: "系统异常",
                        type: "error"
                    });
                    console.log(error);
                });
        },
        analyses_del(row){
            this.$confirm('您确认要删除吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.del(row)
            }).catch((err) => {
                  console.log(err)
            });
        },

        // 添加分组后回调
        addBoxCallback(val){
            if(val == true){
                this.getList()
            }
            this.showAddBox = false
            this.openType = 'add'
            this.currentRow = null
        },

        // 添加子分组
        analyses_add_sub_tree_data(row){
            this.currentRow = row
            this.openType = 'add'
            this.showAddBox = true
        },

        // 编辑分组
        analyses_edit_tree_data(row){
            this.currentRow = row
            this.openType = 'edit'
            this.showAddBox = true
        }
    }
}
</script>
